import type { IObjectViewModel } from '../../../interfaces';
import { SceneItemKind } from '../../../interfaces';
import { DistanceModel } from './Distance.model';
import { DistanceIndicationStrategy } from './DistanceIndicationStrategy';
import type { IIndicationStrategy } from '../Indications.controller';
import type { IIndicationToolFactory } from '../Indications.factory';
import type { IndicationsService } from '../Indications.service';
import type { IValue } from '@/engine/DataFlow/Graph';
import type { IIndicationsViewModelFactory } from '../interfaces';
import type { PlanningAlgorithm } from '@/engine/PlanningAlgorithm/PlanningAlgorithm';
import type { ICommandProcessor } from '../../core/interfaces/Command';
import type { IRemover } from '@/engine/UIPresentation/Interfaces';
import { BaseIndicationAdder } from './BaseIndicationAdder';
import type { CancellationController } from '@/engine/Controllers/Cancellation.controller';

export class DistanceToolFactory implements IIndicationToolFactory {
  private readonly _baseIndicationLabel = 'Distance';

  private readonly _indicationsService: IndicationsService;

  private readonly _cancellationController: CancellationController;

  public constructor(indicationsService: IndicationsService, cancellationController: CancellationController) {
    this._indicationsService = indicationsService;
    this._cancellationController = cancellationController;
  }

  public createIndicationStrategy(
    planningAlgorithm: PlanningAlgorithm,
    commandProcessor: ICommandProcessor,
    remover: IRemover
  ): IIndicationStrategy {
    return new DistanceIndicationStrategy(
      this._indicationsService,
      planningAlgorithm,
      commandProcessor,
      new BaseIndicationAdder(planningAlgorithm, this._indicationsService),
      remover,
      this._cancellationController
    );
  }

  public createIndicationModel(): IValue {
    return new DistanceModel({});
  }

  public createIndicationViewModel(
    vmFactory: IIndicationsViewModelFactory,
    phaseId: string | undefined
  ): IObjectViewModel {
    return vmFactory.createViewModel(
      SceneItemKind.IndicatedDistance,
      phaseId,
      undefined,
      undefined,
      this._indicationsService.getIndicationLabel(this._baseIndicationLabel, SceneItemKind.IndicatedDistance)
    );
  }
}
